import { getPageEntries } from "utils/contentful/api";
import { DynamicComponent } from "components/checkout";
import Head from "next/head";
import { getGiftLayout } from "components/checkout/CheckoutContainer";
import { getCheckoutSession } from "lib/api/checkout";
import { useContext } from "react";
import { CheckoutContext } from "contexts/CheckoutProvider";
import { mergeWithContext } from "utils/checkout";

const Personalize = ({ cmsPage, serverProps, routeNext }) => {
  const { sections, metaTitle } = cmsPage;

  const { session: ctxSession, setGiftDetails } = useContext(CheckoutContext);

  const session = mergeWithContext(serverProps.session, ctxSession);

  const initialValues = {
    firstName: session?.recipientInfo?.childName || "",
    age: session?.recipientInfo?.age || "",
  };

  const updateChildInfo = async ({ firstName, age }) => {
    return await setGiftDetails({ childName: firstName, age }, true);
  };

  const props = {
    updateChildInfo,
    initialValues,
    routeNext,
    useAge: true,
  };

  return (
    <div>
      <Head>
        <title key="title">{metaTitle}</title>
      </Head>
      {sections.map((entry) => (
        <DynamicComponent key={entry.id} entry={entry} {...props} />
      ))}
    </div>
  );
};

Personalize.getLayout = getGiftLayout;

export const getServerSideProps = async (ctx) => {
  const [session, cmsPage] = await Promise.all([
    getCheckoutSession(ctx),
    getPageEntries("personalize-gift"),
  ]);

  return {
    props: {
      cmsPage,
      serverProps: {
        session,
      },
    },
  };
};

export default Personalize;
